export default __webpack_public_path__ + "src/images/packages/shipwreck-lodge/88b5e455fbe47d969c361e7912a32f5b-5.jpeg";